//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
This is a visual clone of the Popular Products Carousel found in the Nu Home project and used (at time of writing) on the AEM-hosted homepage.
The popular-products business logic has been stripped out, in favor of a prop for injecting product SKU IDs or UIDs.
The debug logic from the original has also been stripped out.
 */

import { NsIcon } from "@nuskin/ns-icon";
import { AccountManager } from "@nuskin/ns-account";
import { CartService, SalesEventService } from "@nuskin/ns-shop";
import { events } from "@nuskin/ns-util";
import Carousel from "./Carousel.vue";
import CarouselChevron from "./CarouselChevron.vue";
import Loader from "./Loader.vue";
import globalHelper from "../../mixins/globalHelper";
import Product from "../../models/product";
import Price from "./Price.vue";
import get from "lodash/get";
import {
  findProductsById,
  getProductTranslations
} from "../../services/NsProductContentService";

const OPTIONS = {
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: true
  },
  watchSlidesProgress: true,
  loop: true,
  centeredSlides: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  slidesPerView: 1.5,
  spaceBetween: 20,
  breakpoints: {
    500: {
      slidesPerView: 2
    },
    600: {
      spaceBetween: 30,
      slidesPerView: 2.3,
      centeredSlides: false
    },
    768: {
      slidesPerView: 1
    },
    850: {
      slidesPerView: 1.3,
      centeredSlides: false
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 30,
      centeredSlides: false
    }
  }
};

/**
 * Compares two lists of strings and determines if their contents are the same.
 * @param {string[]} listA
 * @param {string[]} listB
 * @return {boolean}
 */
function compareStringLists(listA, listB) {
  if (listA.length !== listB.length) return false;

  const freqCountsA = {};
  const freqCountsB = {};

  for (const v of listA) freqCountsA[v] = (freqCountsA[v] || 0) + 1;
  for (const v of listB) freqCountsB[v] = (freqCountsB[v] || 0) + 1;

  for (const key in freqCountsA) {
    if (!(key in freqCountsB)) return false;

    if (freqCountsA[key] !== freqCountsB[key]) return false;
  }

  return true;
}

export default {
  name: "NuHomeCloneProductCarousel",
  components: {
    Carousel,
    CarouselChevron,
    Loader,
    NsIcon,
    Price
  },
  mixins: [globalHelper],
  props: {
    /**
     * Carousel title
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * List of product SKU IDs (e.g. "01234567") or UIDs (e.g. "blt0123456789abcdef")
     */
    productIds: {
      type: Array,
      required: true
    },
    country: {
      type: String,
      required: true
    },
    language: {
      type: String,
      required: true
    },
    forceLoading: {
      type: Boolean,
      default: false
    },
    referrer: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      options: OPTIONS,
      internalLoading: false,
      carouselKey: 1,
      rotate: false,
      productTabs: {},
      translations: [],
      products: [],
      productSlugs: [],
      currentTabIndex: 0,
      currentTab: {},
      windowWidth: window.innerWidth,
      salesEvents: [],
      user: null
    };
  },
  computed: {
    addToCartText() {
      if (this.translations) {
        return this.translations.addToCartButton
          ? this.translations.addToCartButton
          : "Add to Cart";
      }
      return "Add to Cart";
    },
    desktopAndUp() {
      return (
        this.$mq === "tablet" ||
        this.$mq === "desktop" ||
        this.$mq === "desktopHD"
      );
    },
    loading() {
      return this.internalLoading || this.forceLoading;
    },
    phabletAndDown() {
      return this.$mq === "mobile" || this.$mq === "phablet";
    },
    headingClass() {
      return this.windowWidth > 1023 ? "heading-2" : "heading-1";
    }
  },
  watch: {
    /**
     * @param {string[] | null | undefined} ids
     * @param {string[] | null | undefined} oldIds
     */
    productIds(ids, oldIds) {
      // Case 0: new list is empty; clear out product data
      if (!ids || !ids.length) {
        this.products = [];

        // Force a rerender of the Swiper carousel
        requestAnimationFrame(() => {
          this.internalLoading = true;
          requestAnimationFrame(() => (this.internalLoading = false));
        });
        return;
      }

      // Case 1: old list is empty; retrieve fresh product data for new list
      if (!oldIds || !oldIds.length) {
        this.getSliderProducts(ids);
        return;
      }

      // Case 2: new and old list are the same; do nothing
      if (compareStringLists(ids, oldIds)) {
        return;
      }

      // Case 3: new list is subset of old list
      if (ids.every(id => oldIds.includes(id))) {
        // Product data is therefore also a subset of the previous data
        this.products = this.products.filter(p => ids.includes(p._id));

        // Force a rerender of the Swiper carousel
        requestAnimationFrame(() => {
          this.internalLoading = true;
          requestAnimationFrame(() => (this.internalLoading = false));
        });
        return;
      }

      // Default case: retrieve fresh product data
      this.getSliderProducts(ids);
    }
  },
  mounted() {
    this.initProductTranslations();
    this.initCtaClickHandler();

    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });

    this.user = {
      isDistributor: AccountManager.isDistributor(),
      isPreferredCustomer: AccountManager.isPreferredCustomer()
    };
  },
  updated() {
    this.initCtaClickHandler();
  },
  async created() {
    this.rotate = window.location;

    SalesEventService.init(true);
    events.getValue(
      events.salesevent.ACTIVE_EVENTS,
      se => this.handleGotSalesEvents(se),
      true
    );
  },
  methods: {
    handleGotSalesEvents(salesEvents) {
      this.salesEvents = salesEvents;
    },

    handleGotUser(user) {
      this.user = user;
    },

    initCtaClickHandler() {
      const $ctaElements = this.$el.querySelectorAll('[data-carousel="cta"]');

      $ctaElements.forEach(cta => {
        cta.addEventListener("keypress", this.handleKeyPress);
      });
    },

    handleKeyPress(e) {
      if (e.key == "Enter") {
        this.handleClick({ nativeEvent: e });
      }
    },

    handleClick(event) {
      // event refers to custom event that contains the swiper instance and the nativeEvent of the clicked slide (not button).
      const { nativeEvent } = event;
      const target = nativeEvent.target;
      let sku = get(target, "dataset.sku");
      if (!sku) {
        // we assume the button will only have spans inside
        sku = get(target, "parentElement.dataset.sku");
      }
      // null check, if null, means the clicked element was not part of the atc button
      return sku ? this.addToCart(sku) : undefined;
    },

    openLink(slug, sku) {
      this.$emit("click-pdp", { slug, sku });
      setTimeout(() => {
        // Go to PDP after sufficient delay to log the user event
        window.location.href = this.buildProductLink(slug, sku);
      }, 1);
    },

    async addToCart(sku) {
      const options = {
        sku: sku && sku.toString(),
        qty: 1,
        userId: "",
        cntryCd: "",
        isAdr: false,
        referrer: this.referrer,
        domain: window.location.hostname
      };
      try {
        this.$emit("click-atc", options);
        await CartService.addSkuToCart(options);
      } catch (error) {
        console.error("Failed to add to cart.", error);
      }
    },

    async getSliderProducts(sliderProductIds) {
      this.internalLoading = true;

      try {
        const products = await findProductsById(
          sliderProductIds,
          this.country,
          this.language
        );

        this.products = sliderProductIds
          .map(id => {
            return [
              id,
              products.find(p => {
                return p.id === id || p.variants.find(v => v.sku === id);
              })
            ];
          })
          .filter(arr => !!arr[1])
          .map(([id, data]) => new Product(id, data))
          .filter(product => {
            return (
              product.hasVariants() &&
              !product.isExclusive() &&
              !product.isNotReleasedForSale() &&
              !product.isOutOfStock()
            );
          });
      } catch (e) {
        console.error(e);
      }

      this.internalLoading = false;
    },

    optimizeImage(imgUrl, width, forceWidth = false) {
      const url = new URL(imgUrl);
      const maxWidth = window.innerWidth;

      if (width) {
        const resolvedWidth = forceWidth ? width : Math.min(maxWidth, width);
        url.searchParams.append("width", resolvedWidth.toString());
      }

      return url.toString();
    },

    initProductTranslations() {
      getProductTranslations(["addToCartButton"], this.country, this.language)
        .then(translations => {
          this.translations = translations;
        })
        .catch(console.error);
    }
  }
};
